import { markRaw, defineAsyncComponent } from 'vue';
import { useDashboardStore } from '@/stores/useDashboardStore';
import { useSlideoutStore } from '@nuxt-common/atomic-ui/app/stores/useSlideoutStore';

const useSlideout = () => {
  const dashboardStore = useDashboardStore();
  const slideoutStore = useSlideoutStore();

  const showSlideout = async (id, title, component, toggle = true, props = {}) => {
    await dashboardStore.setSlideout({
      id,
      title,
      props,
      component: markRaw(defineAsyncComponent(() => component)),
    });

    if (toggle) {
      slideoutStore.toggle(id);
    }
  };

  const toggleSlideout = (id) => {
    slideoutStore.toggle(id);
  };
  const closeSlideout = (id) => {
    slideoutStore.close(id);
  };

  return { showSlideout, toggleSlideout, closeSlideout };
};

export default useSlideout;
